import React, { Fragment } from "react";
import { Skeleton, Layout } from "antd";
import { Link } from "react-router-dom";
import { compose } from "recompose";
import { connect } from "react-redux";
import * as R from "ramda";
import { Content } from "@worcket/common/components/layout";

import logo from "../assets/logo-white.svg";
import { Logo } from "../components/Layout/TopBar/TopBar";
import SkeletonCompanies from "../scenes/Companies/SkeletonCompanies";
import SkeletonTeamList from "../components/team/SkeletonTeamList";
import SkeletonOpportunities from "../components/opportunity/SkeletonOpportunities";
import Page from "../components/display/Page";

import styled from "styled-components/macro";

const SkeletonHeader = styled.header`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  height: 64px;
  background: #ffffff;
  padding: 0 20px;
`;

const HeaderItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  * {
    margin: 0 !important;
  }
`;

const SkeletonContainer = styled.section`
  width: 100%;
  .ant-layout {
    min-height: 100vh;
  }
`;

const SkeletonApp = ({ isSuperadmin }) => {
  return (
    <Fragment>
      <SkeletonHeader>
        <HeaderItem>
          <Link to="/">
            <Logo data-test="logo" src={logo} alt="Worcket" />
          </Link>
        </HeaderItem>
        <HeaderItem>
          <Skeleton
            className="skeleton"
            active
            avatar={false}
            title={{ width: 100, rows: 1 }}
            paragraph={false}
          />
        </HeaderItem>
        <HeaderItem type="avatar">
          <Skeleton
            className="skeleton"
            active
            avatar={{ shape: "circle" }}
            title={false}
            paragraph={false}
          />
        </HeaderItem>
      </SkeletonHeader>
      <SkeletonContainer>
        <Layout>
          {isSuperadmin ? (
            <SkeletonCompanies />
          ) : (
            <Page>
              <Content>
                <SkeletonTeamList />
              </Content>
              <Content>
                <SkeletonOpportunities />
              </Content>
            </Page>
          )}
        </Layout>
      </SkeletonContainer>
    </Fragment>
  );
};

const enhacer = compose(
  connect(
    R.applySpec({
      isSuperadmin: R.pipe(
        R.pathOr([], ["user", "roles"]),
        R.includes("headadmin")
      )
    })
  )
);

export default enhacer(SkeletonApp);
